'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvedAttachmentEntriesForThreadFromProps = undefined;

var _reselect = require('reselect');

var _set = require('transmute/set');

var _set2 = _interopRequireDefault(_set);

var _immutable = require('immutable');

var _getEntry = require('conversations-async-data/indexed-async-data/operators/getEntry');

var _fileAttachmentIdsForThreadFromProps = require('./fileAttachmentIdsForThreadFromProps');

var _getResolvedAttachments = require('./getResolvedAttachments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolvedAttachmentEntriesForThreadFromProps = exports.resolvedAttachmentEntriesForThreadFromProps = (0, _reselect.createSelector)([_getResolvedAttachments.getResolvedAttachments, _fileAttachmentIdsForThreadFromProps.fileAttachmentIdsForThreadFromProps], function (attachmentsState, attachmentIds) {
  if (!attachmentIds || !attachmentIds.size) {
    return (0, _immutable.Map)();
  }

  return attachmentIds.reduce(function (resolvedAttachmentEntries, attachmentId) {
    var entry = (0, _getEntry.getEntry)(attachmentId, attachmentsState);

    if (!entry) {
      return resolvedAttachmentEntries;
    }

    return (0, _set2.default)(attachmentId, entry, resolvedAttachmentEntries);
  }, (0, _immutable.Map)());
});